import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  recommendationsHeading: {
    id: 'ProductRecommendations.recommendationsHeading',
    defaultMessage: 'You might also like',
    description: 'Title for a list of recommended courses',
  },
  executiveEducationHeading: {
    id: 'ProductRecommendations.executiveEducationHeading',
    defaultMessage: 'Executive Education',
    description: 'Heading for an executive education course recommendation',
  },
  executiveEducationDescription: {
    id: 'ProductRecommendations.executiveEducationDescription',
    defaultMessage: 'Short Courses to develop leadership skills',
    description: 'Short description of an executive education course',
  },
  bootcampHeading: {
    id: 'ProductRecommendations.bootcampHeading',
    defaultMessage: 'Boot Camp',
    description: 'Heading for a bootcamp course recommendation',
  },
  bootcampDescription: {
    id: 'ProductRecommendations.bootcampDescription',
    defaultMessage: 'Intensive, hands-on, project based training',
    description: 'Short description of a bootcamp course',
  },
  courseHeading: {
    id: 'ProductRecommendations.courseHeading',
    defaultMessage: 'Courses',
    description: 'Heading for an open course recommendation',
  },
  courseDescription: {
    id: 'ProductRecommendations.courseDescription',
    defaultMessage: 'Find new interests and advance your career',
    description: 'Heading for an open course recommendation',
  },
});

export default messages;
